/* Cardbreakers Dark — theme JS */
(function () {
  'use strict';

  /* Sidebar toggle */
  const sidebar = document.querySelector('[data-sidebar]');
  const toggle = document.querySelector('[data-sidebar-toggle]');
  const backdrop = document.querySelector('[data-sidebar-backdrop]');
  if (toggle && sidebar) {
    toggle.addEventListener('click', () => {
      sidebar.classList.toggle('is-open');
      if (backdrop) backdrop.classList.toggle('is-open');
    });
  }
  if (backdrop) {
    backdrop.addEventListener('click', () => {
      sidebar && sidebar.classList.remove('is-open');
      backdrop.classList.remove('is-open');
    });
  }

  /* Hero slideshow */
  const hero = document.querySelector('[data-hero]');
  if (hero) {
    const dataEl = hero.querySelector('[data-hero-slides]');
    if (dataEl) {
      let slides = [];
      try { slides = JSON.parse(dataEl.textContent); } catch (e) {}
      if (slides.length > 1) {
        let idx = 0;
        const contentEl = hero.querySelector('[data-hero-content]');
        const mediaEl = hero.querySelector('[data-hero-media]');
        const dots = hero.querySelectorAll('[data-slide-idx]');
        const render = (i) => {
          const s = slides[i];
          if (!s) return;
          if (contentEl) {
            contentEl.innerHTML =
              (s.eyebrow ? '<p class="hero__eyebrow">' + s.eyebrow + '</p>' : '') +
              (s.heading ? '<h1 class="hero__heading">' + s.heading + '</h1>' : '') +
              (s.subheading ? '<p class="hero__sub">' + s.subheading + '</p>' : '') +
              (s.button_label ? '<a href="' + (s.button_link || '#') + '" class="btn btn--primary btn--lg">' + s.button_label + '</a>' : '');
          }
          if (mediaEl) {
            mediaEl.innerHTML = s.image ? '<img src="' + s.image + '" alt="' + (s.heading || '') + '">' : '';
          }
          dots.forEach((d, di) => d.classList.toggle('is-active', di === i));
          idx = i;
        };
        dots.forEach((d) => d.addEventListener('click', () => render(parseInt(d.dataset.slideIdx, 10))));
        setInterval(() => render((idx + 1) % slides.length), 6000);
      }
    }
  }

  /* Pack tabs */
  document.querySelectorAll('[data-pack-tabs]').forEach((wrap) => {
    const btns = wrap.querySelectorAll('.pack-tabs__btn');
    const panels = wrap.querySelectorAll('.pack-tabs__panel');
    btns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const i = btn.dataset.tab;
        btns.forEach((b) => b.classList.remove('is-active'));
        panels.forEach((p) => p.classList.remove('is-active'));
        btn.classList.add('is-active');
        const panel = wrap.querySelector('.pack-tabs__panel[data-panel="' + i + '"]');
        if (panel) panel.classList.add('is-active');
      });
    });
  });

  /* Product image gallery */
  const mainImage = document.querySelector('[data-product-main-image]');
  const thumbs = document.querySelectorAll('[data-thumb]');
  if (mainImage && thumbs.length > 0) {
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const fullSrc = thumb.dataset.full;
        if (!fullSrc) return;
        mainImage.src = fullSrc;
        mainImage.removeAttribute('srcset');
        thumbs.forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  }

  /* Welcome popup */
  (function() {
    const KEY = 'cbWelcomePopupShown_v1';
    const popup = document.querySelector('[data-welcome-popup]');
    if (!popup) return;
    try { if (localStorage.getItem(KEY)) return; } catch (e) {}
    setTimeout(() => {
      popup.removeAttribute('hidden');
      requestAnimationFrame(() => popup.classList.add('is-open'));
    }, 8000);
    popup.querySelectorAll('[data-popup-close]').forEach((b) => {
      b.addEventListener('click', () => {
        popup.classList.remove('is-open');
        try { localStorage.setItem(KEY, '1'); } catch (e) {}
        setTimeout(() => popup.setAttribute('hidden', ''), 250);
      });
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) {
        popup.classList.remove('is-open');
        try { localStorage.setItem(KEY, '1'); } catch (e) {}
        setTimeout(() => popup.setAttribute('hidden', ''), 250);
      }
    });
  })();

  /* Add to cart */
  document.querySelectorAll('form[action$="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      if (!window.fetch) return;
      e.preventDefault();
      const submit = form.querySelector('[type="submit"]');
      const originalLabel = submit ? submit.textContent : '';
      if (submit) { submit.disabled = true; submit.textContent = 'Legger til…'; }
      try {
        const data = new FormData(form);
        const res = await fetch('/cart/add.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } });
        if (!res.ok) throw new Error('Add to cart failed');
        const cartRes = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        const cart = await cartRes.json();
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
        });
        if (submit) { submit.textContent = 'Lagt til ✓'; }
        setTimeout(() => { if (submit) { submit.disabled = false; submit.textContent = originalLabel; } }, 1200);
      } catch (err) {
        console.error(err);
        if (submit) { submit.disabled = false; submit.textContent = originalLabel; }
        form.submit();
      }
    });
  });
})();
